import { MainInner } from "@/styles/global";
import { h1 } from "@/styles/typography";
import styled from "styled-components";

const Inner = styled(MainInner)`
  gap: 24px;
  height: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  a {
    color: ${({ theme }) => theme.colors.textHeading};

    svg path {
      stroke: ${({ theme }) => theme.colors.textHeading};
    }
  }
`;

const Title = styled(h1)``;

const CardsWrapper = styled.div`
  display: flex;
  gap: 16px;
  height: 100%;
  width: 100%;
  position: relative;

  .mySwiper {
    width: 100%;
    height: 100%;
    overflow: visible;
    position: relative;
  }
`;

const NavigationWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    justify-content: flex-end;
  }
`;

const Navigation = styled.button`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  background: transparent;

  .firstArrow {
    transform: rotate(90deg);
  }

  svg {
    transform: rotate(-90deg);
    height: 40px;
    width: 40px;
  }

  &:disabled {
    cursor: not-allowed;

    svg path {
      fill: darkgrey;
    }
  }
`;

const S = {
  Inner,
  TitleWrapper,
  Title,
  CardsWrapper,
  NavigationWrapper,
  Navigation,
};

export default S;
